
export function shortenizeYearFormat(stringDate) {
    let bigStringDateSymbolsNumber = 23;
    if (stringDate.length === bigStringDateSymbolsNumber) return `${stringDate.slice(0, 5)} - ${stringDate.slice(13, 19)}${stringDate.slice(21, 23)}`
    else return `${stringDate.slice(0, 14)}${stringDate.slice(16)}`
}